<template>
    <v-form v-model="isValid">
        <div class="font-size-14 grey--text text-right mb-12px mb-md-16px" :style="$vuetify.breakpoint.smAndUp ? 'margin-top:calc((20px + var(--tit-wrap-padding-bottom-sm)) * -1)' : ''"><span class="red--text">*</span> 필수입력 항목입니다.</div>
        <vertical-form-table v-model="form" v-bind="{ items }">
            <template slot="신청자 명">
                <v-row align="center" class="row--xs">
                    <v-col cols="12" md="4">
                        <text-field-primary v-model="form.name" dense placeholder="신청자 명을 입력하세요." />
                    </v-col>
                </v-row>
            </template>
            <template slot="연락처">
                <v-row align="center" class="row--xs">
                    <v-col cols="12" md="4">
                        <v-row align="center" class="row--xxs">
                            <v-col cols="">
                                <text-field-primary v-model="phone1" dense type="number" :rules="phoneRules" />
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col cols="">
                                <text-field-primary v-model="phone2" dense type="number" :rules="phoneRules" />
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col cols="">
                                <text-field-primary v-model="phone3" dense type="number" :rules="phoneRules" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </template>
        </vertical-form-table>

        <div class="btn-wrap btn-wrap--lg">
            <v-row justify="center" class="row--xs">
                <v-col cols="6" sm="auto">
                    <btn-secondary2 x-large class="w-100 min-w-sm-160px" @click="$emit('prev')">뒤로가기</btn-secondary2>
                </v-col>
                <v-col cols="6" sm="auto">
                    <btn-primary2 v-bind="{ disabled }" x-large class="w-100 min-w-sm-160px" @click="$emit('remove', form)">신청취소하기</btn-primary2>
                </v-col>
            </v-row>
        </div>
    </v-form>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATUS } from "@/assets/variables";
import { attrs_input, attrs_controls_common } from "@/assets/variables";

import PageSection from "@/sets/styles/pages/page-section.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import TermsOfAgreementsShort from "@/components/client/terms/terms-of-agreements-short.vue";
// import ImagesInput from "@/components/console/dumb/images-input.vue";
import BtnPrimary2 from "@/components/publish/parents/buttons/btn-primary2.vue";
import BtnSecondary2 from "@/components/publish/parents/buttons/btn-secondary2.vue";
import TextFieldPrimary from "@/components/publish/parents/forms/text-field-primary.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import RadioPrimary from "@/components/publish/parents/forms/radio-primary.vue";
import CheckboxPrimary from "@/components/publish/parents/forms/checkbox-primary.vue";
import CheckboxPrimaryArray from "@/components/publish/parents/forms/checkbox-primary-array.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";

const items = [
    {
        term: "신청자 명",
        required: true,
    },
    {
        term: "연락처",
        required: true,
    },
].map((item) => ({ ...item, outlined: true }));

export default {
    components: {
        PageSection,
        VerticalFormTable,
        TermsOfAgreementsShort,
        // ImagesInput,
        BtnPrimary2,
        BtnSecondary2,
        TextFieldPrimary,
        VDateField,
        RadioPrimary,
        CheckboxPrimary,
        CheckboxPrimaryArray,
        TxtPrimary,
    },
    props: {
        value: { type: Object, default: null },
    },
    data() {
        return {
            attrs_input,
            attrs_controls_common,

            work: null,
            form: this.$props.value,
            // form: {},
            limitation: {},

            items,
            isValid: false,
            isTermsValid: undefined,

            phone1: null,
            phone2: null,
            phone3: null,

            limitEquipments: [],
            phoneRules: [(v) => !!v || "연락처를 입력해주세요.", (v) => (v && v.length <= 4) || "4글자까지만 입력해주세요."],
        };
    },
    computed: {
        phone() {
            const { phone1, phone2, phone3 } = this;
            if (!!phone1 && !!phone2 && !!phone3) return `${phone1}-${phone2}-${phone3}`;
            else return null;
        },
        disabled() {
            return !this.isValid;
        },
    },
    methods: {
        emit() {
            this.form = { ...this.form };
        },
    },
    mounted() {},
    watch: {
        phone() {
            this.form = { ...this.form, phone: this.phone };
        },
        value() {
            this.form = { ...this.value };
        },
    },
};
</script>
